export enum SLEvent {
	Ready = 'Ready',
	ProfileLinkClick = 'profileLinkClick',
	DisablePageScroll = 'disablePageScroll',
	EnablePageScroll = 'enablePageScroll',
	ShowBackdrop = 'showBackdrop',
	HideBackdrop = 'hideBackdrop',
	ChangeBreadcrumb = 'changeBreadcrumb',
	ChangeQuickLinks = 'changeQuickLinks',
	ChangeMoodImage = 'changeMoodImage',
	ResetMoodImage = 'resetMoodImage',
	ShowMoodImage = 'showMoodImage',
	HideMoodImage = 'hideMoodImage',
	RegisterStickyListener = 'registerStickyListener',
	UnregisterStickyListener = 'unregisterStickyListener',
}

export interface ISlEventBus {
	on: <T = any>(eventName: SLEvent, callback: (meta?: string, payload?: T) => void) => void;
	emit: <T = any>(eventName: SLEvent, meta?: string, payload?: T) => void;
}
